import React, { Fragment } from 'react';

const MiniCartProduct = ({
    product,
    onCartItemIncrement,
    onCartItemDecrement,
    onCartItemRemove
}) => (
        <div className="cart__product-row">
            <div className="cart__product-row__image">
                {product.image != null ? <img src={product.image} alt={product.name} /> : <i className="fa fa-picture-o"></i> }                
            </div>
            <div className="cart__product-row__info">
                <div className="cart__split-row">
                    <h3>{product.articleNumber} <br/> {product.name}</h3>
                    <button className="cart__product-row__remove-button" onClick={onCartItemRemove}></button>
                </div>
                {!product.hidePriceForRival && !product.hideZeroPrice ?(<div className="cart__product-row__price">
                    {product.campaignPrice ? (
                        <Fragment>
                            <span>{product.campaignPrice}</span >&nbsp;<span className="old-price">{product.price}</span>
                        </Fragment>
                    ) : product.price}
                </div>):null}
                <div className="cart__product-row__quantity">
                    <button
                        className="cart__product-row__quantity-action"
                        onClick={onCartItemDecrement}>
                        <span>-</span>
                    </button>
                    <div className="cart__product-row__quantity-display">
                        <span>{product.quantity}</span>
                    </div>
                    <button
                        className="cart__product-row__quantity-action cart__product-row__quantity-action--plus"
                        onClick={onCartItemIncrement}>
                        <span>+</span>
                    </button>
                </div>
            </div>
        </div>
    );

export default MiniCartProduct